import gql from 'graphql-tag';
import LeadFragments from '../fragments/lead.fragments';

const DELETE_LEAD_NOTE = gql`
  mutation DeleteLeadNote($params: DeleteLeadNoteParams!) {
    deleteLeadNote(params: $params) {
      ...LeadFields
      ...LeadLoiFiles
      ...LeadNotes
      ...LeadSellerNotes
      ...LeadUser
      ...LeadListing
      ...LeadMetrics
      ...LeadMeta
      ...LeadAnalyticsEvents
      ...LeadChannel
    }
  }

  ${LeadFragments.fields}
  ${LeadFragments.loiFiles}
  ${LeadFragments.notes}
  ${LeadFragments.sellerNotes}
  ${LeadFragments.user}
  ${LeadFragments.listing}
  ${LeadFragments.metrics}
  ${LeadFragments.meta}
  ${LeadFragments.analyticsEvents}
  ${LeadFragments.channel}
`;

export default DELETE_LEAD_NOTE;
